function getRouterBase(pathname = '/') {
  return pathname === '/admin' || pathname.startsWith('/admin/') ? '/admin/' : '/';
}

function normalizeLegacyHashUrl(location, history) {
  if (!location.hash?.startsWith('#/')) return false;

  const base = getRouterBase(location.pathname);
  const basePath = base === '/' ? '' : base.slice(0, -1);
  history.replaceState(history.state || null, '', `${basePath}${location.hash.slice(1)}`);
  return true;
}

module.exports = { getRouterBase, normalizeLegacyHashUrl };
